import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import type { NavItemMega } from "@/lib/constants";

export function MegaMenuContent({ item }: { item: NavItemMega }) {
  return (
    <div className="flex w-[560px]">
      {/* Left column — items with icons */}
      <div className="flex-1 p-4">
        <ul className="grid gap-0.5">
          {item.children.map((child) => (
            <li key={child.label}>
              <NavigationMenuLink asChild>
                <Link
                  href={child.href}
                  className="group/link flex items-start gap-3 rounded-lg p-3 transition-colors hover:bg-accent"
                >
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                    <child.icon className="h-[18px] w-[18px]" />
                  </span>
                  <div className="space-y-0.5">
                    <p className="text-sm font-medium leading-tight">
                      {child.label}
                    </p>
                    <p className="text-xs leading-snug text-muted-foreground">
                      {child.description}
                    </p>
                  </div>
                </Link>
              </NavigationMenuLink>
            </li>
          ))}
        </ul>
      </div>

      {/* Separator */}
      <div className="w-px bg-border" />

      {/* Right column — featured content */}
      <div className="w-[210px] bg-accent/40 p-5 flex flex-col">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-primary/60 mb-3">
          Polecane
        </p>
        <div className="flex flex-col flex-1 justify-between">
          <div>
            <p className="text-sm font-medium leading-snug">
              {item.featured.title}
            </p>
            <p className="mt-1.5 text-xs leading-snug text-muted-foreground">
              {item.featured.description}
            </p>
          </div>
          <NavigationMenuLink asChild>
            <Link
              href={item.featured.href}
              className="mt-4 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary/10 px-3 py-1.5 text-xs font-medium text-primary transition-colors hover:bg-primary/20"
            >
              {item.featured.ctaLabel}
              <ArrowRight className="h-3 w-3" />
            </Link>
          </NavigationMenuLink>
        </div>
      </div>
    </div>
  );
}
